<template>
  <el-select v-model="value" placeholder="设备状态" multiple style="width:120px;" @change="change">
    <el-option v-for="(item,i) in options" :key="i" v-bind="item">
    </el-option>
  </el-select>
</template>

<script>
  export default {
    methods: {
      change() {
        this.$emit("change", this.value);
      }
    },
    data() {
      return {
        options: [
          //   {
          //   value: -1,
          //   label: '故障'
          // }, 
          {
            value: 0,
            label: '离线'
          }, {
            value: 1,
            label: '空闲'
          }, {
            value: 2,
            label: '正在扫台'
          }, {
            value: 3,
            label: '正在录音'
          }
        ],
        value: ""
      };
    }
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Selectors/DeviceStatus.vue